/**
* Round half up ('round half towards positive infinity')
* Negative numbers round differently than positive numbers.
*/
export function round(num, decimalPlaces = 0) {
 let numb = 
 num = Math.round(num + "e" + decimalPlaces);
 return Number(num + "e" + -decimalPlaces);
}
export function returnBasenameUrl(){
    let basenurl = (process.env.PUBLIC_URL) ? process.env.PUBLIC_URL : "";
    let finalurl = basenurl;
    if(basenurl.length<=0) finalurl = "/"
    else if(basenurl==".") finalurl =  "/"
    else if(basenurl.endsWith("/")) finalurl = basenurl;
    else finalurl = basenurl+"/";
    console.log("=JS utils=, returnBasenameUrl(), finalurl=",finalurl);
    return finalurl;
}